
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createNoteComment",
      resolverType: "mutation",
      routePath: "/createNoteComment",
      httpMethod: "POST",
    });
  